import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export function HeaderBanner() {
  return <div className="w-full py-12 md:py-16 relative overflow-hidden" style={{
    backgroundColor: '#1e3d2f'
  }} data-id="element-747">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#c8a84b 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-748" />
      <div className="max-w-4xl mx-auto px-4 md:px-8 relative z-10" data-id="element-749">
        <div className="flex items-center gap-2 mb-4" data-id="element-750">
          <Link to="/" className="text-xs font-bold uppercase tracking-widest transition-colors hover:text-white" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-751">
            Home
          </Link>
          <ChevronRightIcon size={12} style={{
          color: '#a0c8b0'
        }} data-id="element-752" />
          <span className="text-xs font-bold uppercase tracking-widest" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-753">
            Members
          </span>
          <ChevronRightIcon size={12} style={{
          color: '#a0c8b0'
        }} data-id="element-754" />
          <span className="text-xs font-bold uppercase tracking-widest" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-755">
            Constitution
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold uppercase" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#ffffff'
      }} data-id="element-756">
          Constitution & By-Laws
        </h1>
        <p className="mt-3 text-base" style={{
        color: '#a0c8b0',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-757">
          Fenton Lakes Sportsman's Club — Governing Document
        </p>
        <div className="w-16 h-1 mt-6 rounded-full" style={{
        backgroundColor: '#c8a84b'
      }} data-id="element-758" />
      </div>
    </div>;
}